import { Helmet } from "react-helmet";
import JobDetailsLayout from "../sections/careers/jobDetails/jobDetailsLayout";
import { useParams } from "react-router-dom";

const JobDetailsPage = () => {
    let { job } = useParams();

    return (
        <>
            <Helmet>
                <title>code3x Job Details</title>
            </Helmet>

            <JobDetailsLayout job={job}/>
        </>
    );
}

export default JobDetailsPage;